import prject1 from './images/royalBrothers.png'
import project2 from './images/tata1mg.png'
export const projects = [
	{
		// img: 'https://beta.techcrunch.com/wp-content/uploads/2016/08/screenshot-2016-08-25-03-51-30.png?w=680',
		img : `${prject1}`,
		// img: '',
		title: 'Royal Brothers.com',
		des: 'We are a bunch of millennials focused on building India’s largest mobility solutions provider. Our focus has led us to build a platform providing rentals spanning across 14 states, 43 cities and 3 international cities.',
		demo: '',
		live: ' https://symphonious-cupcake-6a58b9.netlify.app/',
		gitHub: 'https://github.com/saintlypioneer/RoyalBrothersReact',
		technologies: ['React,',"Javascript," ,'CSS,','Chakra UI'],
	},
	{
		// img: 'https://s01.sgp1.digitaloceanspaces.com/large/816287-41227-atbuqceluy-1473660885.png',
		img :`${project2}`,
		title: 'TATA 1mg.com',
		des: 'India’s leading digital consumer healthcare platform we brings to you an online platform, which can be accessed for all your health needs',
		demo: '',
		live: 'https://tata-1mg-clon.netlify.app/',
		gitHub: 'https://github.com/pranshushuklagithub/tata1mg-clone',
		technologies: ['JavaScript,',"HTML," ,'CSS,',"API"],
	}
];
